'use client';
/**
 * Проверяет, что целевой элемент находится на том же уровне, что и родственный элемент.
 *
 * Используется для фильтрации дочерних элементов, имеющих такой же селектор родственного элемента.
 * */ const onSameLevel = (target, sibling, /**
     * Селектор, использующийся для поиска родительского узла.
     * Например, '[role="tablist"]', '.ds-Typography-root'
     * */ parentSelector)=>{
    return target.closest(parentSelector) === sibling.closest(parentSelector);
};

export { onSameLevel };
//# sourceMappingURL=onSameLevel.js.map
